import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectNishitsunaisunHeight from 'components/site/select_nishitsunaisun_height'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectNishitsunaisunHeightStart: state.searchFormCondition.selectNishitsunaisunHeightStart,
  selectNishitsunaisunHeightFinish: state.searchFormCondition.selectNishitsunaisunHeightFinish,
})

const NishitsunaisunHeightContainer = connect(mapStateToProps, mapDispatchToProps)(SelectNishitsunaisunHeight)

export default NishitsunaisunHeightContainer
